import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { IMAGES } from "@/data/site";
import { scrollToId } from "@/lib/scroll";

const PARAGRAPHS = [
    "TECNO-LAV è un'azienda metalmeccanica a conduzione familiare con sede a Brivio, in provincia di Lecco.",
    "Ci occupiamo di lavorazioni meccaniche e della realizzazione di pezzi, stampi e prototipi in ferro e alluminio.",
    "Lavoriamo direttamente sulle esigenze del cliente, con un approccio pratico, flessibile e orientato alla qualità del risultato.",
    "Dalla lavorazione alla realizzazione del componente, mettiamo a disposizione competenze, macchinari e attenzione ai dettagli per trasformare le richieste in soluzioni concrete.",
];

const AziendaText = () => (
    <div>
        <Reveal>
            <Eyebrow number="01" label="Azienda" dark />
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-tl-ink sm:text-3xl lg:text-4xl">
                La nostra esperienza,
                <br />
                il nostro lavoro<span className="text-tl-orange">.</span>
            </h2>
        </Reveal>
        <Reveal delay={0.18}>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-tl-mutedDark">
                {PARAGRAPHS.map((p) => (
                    <p key={p.slice(0, 24)}>{p}</p>
                ))}
            </div>
        </Reveal>
        <Reveal delay={0.26}>
            <button
                type="button"
                data-testid="azienda-cta"
                onClick={() => scrollToId("attrezzature")}
                className="group mt-10 inline-flex items-center gap-3 border border-tl-ink px-7 py-3.5 font-mono-tl text-xs font-semibold uppercase tracking-[0.2em] text-tl-ink transition-colors duration-300 hover:border-tl-orange hover:bg-tl-orange hover:text-tl-dark"
            >
                Scopri TECNO-LAV
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
        </Reveal>
    </div>
);

const AziendaImage = () => (
    <Reveal delay={0.15} className="relative">
        <div className="relative">
            <div className="absolute -left-3 -top-3 h-full w-full border border-tl-orange/50" />
            <img
                src={IMAGES.azienda}
                alt="Dettaglio di lavorazione meccanica su componente metallico nell'officina TECNO-LAV di Brivio"
                loading="lazy"
                className="relative h-full min-h-[320px] w-full object-cover grayscale-[15%]"
            />
            <div className="absolute bottom-0 left-0 bg-tl-dark px-6 py-4">
                <p className="font-mono-tl text-[11px] uppercase tracking-[0.25em] text-tl-orange">Azienda familiare</p>
                <p className="mt-1 font-display text-sm font-semibold text-white">Brivio — Provincia di Lecco</p>
            </div>
        </div>
    </Reveal>
);

export default function Azienda() {
    return (
        <section id="azienda" data-testid="azienda-section" className="blueprint-grid-dark relative bg-tl-light py-20 md:py-28">
            <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-12">
                <AziendaText />
                <AziendaImage />
            </div>
        </section>
    );
}
